import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TopMenuPublicProps } from '@om-fe/core/pages/theme1/parts/top-menu';
import TopMenu from './top-menu';
import BreakpointWrapper from '@om-fe/core/components/breakpoint-wrapper/breakpoint-wrapper';
import { AppState } from '@om-fe/core/types';
import LiveOnlyTopMenu from '@om-fe/core/pages/theme1/parts/live-only-top-menu';
import { hasUpcomingEvents } from '@om-fe/core/utils/config';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import { nextEventsId } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.constants';
import { EMRoutingContextInterface } from '@om-fe/core/routing/utils';
import withTranslation from '@om-fe/core/core/i18n/with-translation';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import withRouting from '@om-fe/core/core/routing/with-routing';
import { PlatformTypes } from '@om-fe/utils';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';

interface HeaderDefaultProps {
    readonly hasSportNav: boolean;
}

type HeaderPublicProps = TopMenuPublicProps
    & Partial<HeaderDefaultProps>;

interface HeaderStoreProps {
    readonly disciplineId?: string;
    readonly hasNoHeader: boolean;
    readonly deviceType?: PlatformTypes;
}

type HeaderProps = HeaderPublicProps
    & HeaderStoreProps
    & I18nContextInterface
    & EMRoutingContextInterface;

function HeaderComponent (
    {
        defaultSearchMap,
        hasNoHeader,
        searchTabsHasMatchTab,
        searchTabsHasTournamentTab,
        searchRouteName,
    }: HeaderProps) {

    const { gettext } = useI18NContext();

    if (hasNoHeader) {
        return null;
    }

    return (
        <>
            <BreakpointWrapper breakpoints={[Breakpoints.Small, Breakpoints.Medium]}>
                {hasUpcomingEvents() ? (
                    <TopMenu
                        defaultSearchMap={defaultSearchMap}
                        searchTabsHasMatchTab={searchTabsHasMatchTab}
                        searchTabsHasTournamentTab={searchTabsHasTournamentTab}
                        searchPlaceholder={gettext('Search')}
                        searchRouteName={searchRouteName}
                    />
                ) : (
                    <LiveOnlyTopMenu />
                )}
            </BreakpointWrapper>
        </>
    );
}

const Header: React.ComponentType<HeaderPublicProps> = compose<React.ComponentType<HeaderPublicProps>>(
    withTranslation(),
    withRouting(),
    connect<HeaderStoreProps>(
        (state: AppState): HeaderStoreProps => {
            const { meta, match } = state.routing;

            return {
                disciplineId: match?.params?.nextEventsDisciplineId ? nextEventsId : match?.params?.disciplineId,
                hasNoHeader: !!meta?.hasNoHeader,
                deviceType: state.deviceInfo?.platform.type,
            };
        },
    ),
)(HeaderComponent);

export default Header;
